import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {MedicalRecordSearchParams} from '@/features/medical-records/types'
import {RangeDatePicker} from '@/components/commons/range-date-picker/RangeDatePicker'
import {formatDateToSearchParams} from '../../utils'

export const MedicalRecordDateRangeFilter = () => {
    const {searchParams, setSearchParams} = useParsedSearchParams(MedicalRecordSearchParams)

    return (
        <RangeDatePicker
            canSelectOneDay
            onClear={() => setSearchParams({endDate: undefined, startDate: undefined})}
            onConfirm={({from, to}) =>
                from && to ? setSearchParams(formatDateToSearchParams({startDate: from, endDate: to})) : undefined
            }
            values={
                searchParams.endDate && searchParams.startDate
                    ? {from: new Date(searchParams.startDate), to: new Date(searchParams.endDate)}
                    : {from: undefined, to: undefined}
            }
        />
    )
}
